export default __webpack_public_path__ + "media/813b1b422d10e9599ecd316c486950051875cb8a07d16d0a565c7f5d63effe69.svg";